import { cleanUpWeightHistoryList, getWeightHistoryThunk } from "../../../reducers/weightHistoryReducer";
import { AppDispatch } from "../../../store";
import { getQueryString } from "../../../utils/getQueryString";

export const resetWeightHistoryList = (dispatch: AppDispatch) => {
  const containerId = getQueryString("cid");
  dispatch(cleanUpWeightHistoryList());
  dispatch(getWeightHistoryThunk(Number(containerId)));
};
